import React from "react";
import LoyaltyStatus from "./component/LoyaltyStatus";
import {createRoot} from "react-dom/client";

export default () => {

  const dom = document.querySelector('[data-loyalty-status]');
  if (dom) {
    const root = createRoot(dom);
    root.render(<LoyaltyStatus/>);
  }

}
